import React from 'react';
import './ec2ExTableCell.css';

const Ec2ExTableCell = ({instance, header, formattedInstance}) => {

  let cellContents;

  if (header.title === 'Debug') {
    cellContents = JSON.stringify(formattedInstance);
  } else if (header.find) {
    if (instance[header.find[0]].find(ele => ele[header.find[1]] === header.find[2])) {
      cellContents = instance[header.find[0]].find(ele => ele[header.find[1]] === header.find[2]).Value;
    } else {
      cellContents = 'Tag not found';
    }
  } else {
    cellContents = instance[header.key];
    if (instance[header.key] === false) cellContents = 'False';
    if (instance[header.key] === true) cellContents = 'True';
  }

  if (typeof cellContents === 'object') cellContents = JSON.stringify(cellContents);

  return (
    <td>
      <div>{cellContents}</div>
    </td>
  );

};

export default Ec2ExTableCell;


// WEBPACK FOOTER //
// ./src/components/content/ec2Explorer/ec2ExMain/ec2ExTableRow/ec2ExTableCell/ec2ExTableCell.js